(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
  , requireOne = require('validity-require-one')
  , tourShowSchema = require('./tour-show-schema')
  , locationSchema = require('./location-schema')
const required = require('@clocklimited/validity-required')

module.exports = function () {

  return schemata(
    { _id:
      { type: String
      }
    , name:
      { type: String
      , validators: { all: [ required ] }
      }
    , agents:
      { type: Array
      , validators:
        { all: [ required ]
        }
      }
    , artist:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , startLocation:
      { type: locationSchema
      , validators: { all: [ required ] }
      , defaultValue: null
      }
    , shows:
      { type: schemata.Array(tourShowSchema)
      , validators: { all: [ requireOne([ 'shows', 'pencilledShows' ], 'Shows are required') ] }
      }
    , pencilledShows:
      { type: schemata.Array(tourShowSchema)
      }
    , freeDays:
      { type: Array
      }
    , createdDate:
      { type: Date
      , defaultValue: function () { return new Date() }
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/tour/schema.js","/components/service/tour")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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